import SessionExpiredCard from "components/card/session-expired/SessionExpiredCard";
import ApplicationContainer from "components/application-container/ApplicationContainer";

interface SessionExpiredPageProps {
    beginUrl?: string;
}

const SessionExpiredPage = ({ beginUrl = "/invitation" }: SessionExpiredPageProps) => {
    return (
        <>
            <title>Session Expired | AAA Life</title>
            <ApplicationContainer data-testid="session-expired-page">
                <SessionExpiredCard beginUrl={beginUrl} />
            </ApplicationContainer>
        </>
    );
};

export default SessionExpiredPage;
